import { Page } from 'layouts/Page';
import { FC } from 'react';
import { Dashboard } from 'components/Dashboard';
import { EASSpinner } from 'components/EASSpinner';

export const DashboardPage: FC = () => {
	return (
		<Page title="EAS Dashboard">
			<Dashboard />
			{/* <EASSpinner /> */}
		</Page>
	);
};
